(function() { module.exports = this["wp"]["editor"]; }());


//////////////////
// WEBPACK FOOTER
// external {"this":["wp","editor"]}
// module id = 1
// module chunks = 0 1 2